import { connect } from 'react-redux';

import BaseMenu from '../base/base-menu';

import MobileMenu from '../../components/shared/header/mobile-menu';

const mapStateToProps = (state, ownProps) => ({
    storesGrouped: state.stores.storesGrouped,
    multiCountryShipping: state.configs.multiCountryShipping,
    currentMunicipality: state.municipalities.currentMunicipality,
});

const mapDispatchToProps = (dispatch) => ({

});

const MobileMenuConnector = connect(mapStateToProps, mapDispatchToProps)(MobileMenu);

export default BaseMenu(MobileMenuConnector);



/** WEBPACK FOOTER **
 ** ./src/containers/menus/mobile-menu-connector.js
 **/